var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeRedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90909 0H3.18182C2.65364 0 2.20182 0.318182 2.01091 0.776364L0.0890909 5.26273C0.0318182 5.40909 0 5.56182 0 5.72727V7C0 7.7 0.572727 8.27273 1.27273 8.27273H5.28818L4.68364 11.1809L4.66455 11.3845C4.66455 11.6455 4.77273 11.8873 4.94455 12.0591L5.61909 12.7273L9.80636 8.53364C10.0418 8.30455 10.1818 7.98636 10.1818 7.63636V1.27273C10.1818 0.572727 9.60909 0 8.90909 0ZM8.90909 7.63636L6.14727 10.3982L6.85364 7H1.27273V5.72727L3.18182 1.27273H8.90909V7.63636ZM11.4545 0H14V7.63636H11.4545V0Z",
    fill: "#E45454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeRedIcon);
export default __webpack_public_path__ + "static/media/dislike-red-icon.0e88d36faef54a0b3171595311aab937.svg";
export { ForwardRef as ReactComponent };